import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'lib-notice-panel',
    templateUrl: './notice-panel.component.html',
    styleUrl: './notice-panel.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, MatIconModule]
})
export class NoticePanelComponent {
  margin = input<boolean>(true);
  icon = input<'ico_info'>('ico_info');
}
